declare const ym: (id: number, action: string, options?: Record<string, unknown>) => void;

export const initMetrika = (): void => {
  const COUNTER_ID = Number(process.env.REACT_APP_COUNTER_ID);
  if (isNaN(COUNTER_ID) || COUNTER_ID === 0) {
    return;
  }

  try {
    const role = localStorage.getItem('role') || '';
    if (role.toLowerCase() === 'worksupport') {
      return;
    }
  } catch (e) {
    // Silently fail
  }

  const win = window as unknown as Record<string, unknown>;
  const methodName = 'ym';

  if (!win[methodName]) {
    win[methodName] = function (...args: unknown[]) {
      ((win[methodName] as { a?: unknown[] }).a =
        (win[methodName] as { a?: unknown[] }).a || []).push(args);
    };
  }

  (win[methodName] as { l?: number }).l = Date.now();

  for (let j = 0; j < document.scripts.length; j++) {
    if (
      document.scripts[j].src === `https://mc.yandex.ru/metrika/tag.js?id=${COUNTER_ID}`
    ) {
      return;
    }
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://mc.yandex.ru/metrika/tag.js?id=${COUNTER_ID}`;
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode?.insertBefore(script, firstScript);

  if (typeof ym !== 'undefined') {
    ym(Number(COUNTER_ID), 'init', {
      ssr: true,
      webvisor: true,
      clickmap: true,
      ecommerce: 'dataLayer',
      referrer: document.referrer,
      url: location.href,
      accurateTrackBounce: true,
      trackLinks: true,
    });
  } else {
    //
  }
};
